const readFileAsync = (
  files: FileList,
  callback: (result: string | ArrayBuffer | null, type: string | undefined) => void
) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let type: string | undefined = undefined

    let result: string | ArrayBuffer | null = ''

    if (files instanceof FileList && files.length !== 0) {
      reader.readAsBinaryString(files[0])

      type = files[0].type

      reader.onload = () => {
        callback(reader.result, type)
      }

      reader.onerror = reject
    } else {
      callback(result, type)
    }
  })
}

export default readFileAsync
